/*
  Mobil nakis onizleme — Easify Product Personalizer onizlemesinin nakis
  bolgesini kirpip buyuterek gosterir. Oncelik: kisisellestirme
  seceneklerinin hemen altina tam genislik inline serit; Easify'in
  options koku bulunamazsa sag altta yuzen kutuya geri duser.
  Sadece kisisellestirme template'inde ve mobil genislikte calisir.

  Cizim: Easify'in canvas'i mobilde kucuk (kare galeride ~290px) oldugu
  icin oradan kopyalamak bulanik. Bu yuzden nakis, Easify'in option set
  verisinden (window.TPOConfigs) ve musterinin secimlerinden arka planin
  kendi cozunurlugunde yeniden cizilir; Easify renderer kurallariyla ayni
  (optionLayer: fontSize = size*15, anchor/offset, max width kucultmesi).
  Veri okunamazsa Easify canvas'indan kopyalamaya geri duser.
*/
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  /*
    Nakis bolgesi: canvas oranlari (0-1). Urun tipine gore theme.liquid
    icindeki window.BSNakisCrop ile gelir; gelmezse polo varsayilani.
    rotate: 90 -> kirpilan bolge saat yonunde cevrilir (kolda asagidan
    yukari okunan dikey nakis seritte yatay okunur).
  */
  var CROP = window.BSNakisCrop || { x: 0.44, y: 0.64, w: 0.53, h: 0.24 };
  var ROTATE = CROP.rotate === 90;
  var FLOAT_WIDTH = 150;
  var FONT_SCALE = 15; /* Easify: font px = size * 15 (arka plan pikseli) */
  var LETTER_SPACING = 0.5; /* Easify metinleri letterSpacing .5 ile cizer */

  var wrap;
  var label;
  var canvas;
  var ctx;
  var mode = ''; /* 'inline' | 'floating' */
  var model; /* undefined: kurulmadi, false: veri yok -> kopyalama modu */
  var images = {};
  var lastKey = '';

  /*
    Serit icin cikis noktasi arar. Easify secenekleri de bir
    "easify portal" kapsayicisinin icinde render ediliyor; dogru hedef
    secenek widget'inin koku olan .po-productPageOptions-root. Serit,
    bu kokun icinde bulundugu portal'in hemen arkasina yerlesir.
    Bulunamazsa satin alma butonlari blogunun ustune koyar.
  */
  function findAnchor() {
    var opts = document.querySelector('.po-productPageOptions-root');
    if (opts) {
      return { el: opts.closest('.easify') || opts, position: 'afterend' };
    }
    var buyButtons = document.querySelector('.buy-buttons-block');
    if (buyButtons) return { el: buyButtons, position: 'beforebegin' };
    return null;
  }

  function scrollToGallery() {
    var target = document.querySelector('media-gallery');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function ensureBox() {
    if (wrap && document.body.contains(wrap)) return true;

    wrap = document.createElement('div');
    label = document.createElement('div');
    label.textContent = 'NAKIŞ ÖNİZLEME';
    label.style.cssText =
      'font-size:10px;letter-spacing:.08em;color:#666;margin:0 0 4px 2px;';
    canvas = document.createElement('canvas');
    canvas.style.cssText = 'display:block;width:100%;height:auto;cursor:pointer;';
    canvas.addEventListener('click', scrollToGallery);
    wrap.appendChild(label);
    wrap.appendChild(canvas);
    ctx = canvas.getContext('2d');
    if (ctx) ctx.imageSmoothingQuality = 'high';
    lastKey = '';

    var anchor = findAnchor();
    if (anchor) {
      mode = 'inline';
      wrap.style.cssText =
        'display:none;margin:12px 0;padding:6px;background:#fff;border:1px solid #e5e5e5;';
      anchor.el.insertAdjacentElement(anchor.position, wrap);
    } else {
      mode = 'floating';
      wrap.style.cssText =
        'display:none;position:fixed;right:12px;bottom:160px;z-index:20;' +
        'width:' + FLOAT_WIDTH + 'px;padding:6px;background:#fff;' +
        'border:1px solid #e5e5e5;box-shadow:0 2px 12px rgba(0,0,0,.18);';
      document.body.appendChild(wrap);
    }
    return true;
  }

  /* ── Easify verisi ─────────────────────────────────────────────── */

  function parse(value) {
    if (!value) return null;
    if (typeof value === 'object') return value;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  /* Urune atanmis option set: aktif olan onde, sonra en son olusturulan (Easify kurali) */
  function findOptionSet() {
    var cfg = window.TPOConfigs;
    if (!cfg || !cfg.current_product || !cfg.option_sets_searchable) return null;
    var gid = 'gid://shopify/Product/' + cfg.current_product.id;
    var best = null;
    cfg.option_sets_searchable.forEach(function (entry) {
      var set = entry && entry.data;
      if (!set || !set.option_set_products) return;
      var assigned = set.option_set_products.some(function (p) {
        return p && p.product_id === gid;
      });
      if (!assigned) return;
      if (
        !best ||
        (set.status === 1 && best.status !== 1) ||
        (set.status === best.status && String(set.createdAt) > String(best.createdAt))
      ) {
        best = set;
      }
    });
    return best;
  }

  /*
    Cizilebilir model: CUSTOM arka plan + duz metin ve image swatch
    katmanlari. Desteklenmeyen bir sey varsa (egri metin, efekt, baska
    katman tipi) false doner ve serit Easify canvas'ini kopyalar.
  */
  function buildModel() {
    var set = findOptionSet();
    if (!set) return false;
    var extra = parse(set.additional_data);
    var bg = extra && extra.live_preview_background;
    if (!bg || bg.type !== 'CUSTOM' || !bg.image_url || !bg.width || !bg.height) return false;

    var options = set.options || [];
    var byId = {};
    options.forEach(function (o) {
      byId[o.id] = o;
    });

    var layers = [];
    var sorted = options.slice().sort(function (a, b) {
      return a.sort_order - b.sort_order;
    });
    for (var i = 0; i < sorted.length; i++) {
      var o = sorted[i];
      var lp = parse(o.live_preview_transform);
      if (!lp || !lp.enabled) continue;
      var t = lp.transforms && lp.transforms[0];
      if (!t) continue;
      if (o.type === 'text-box') {
        if (parseFloat(t.arc) || t.circular) return false;
        if (t.text_effect_type && t.text_effect_type !== 'none') return false;
        var link = lp.color_swatch_link;
        layers.push({
          kind: 'text',
          option: o,
          t: t,
          colorOption: link && link.enabled ? byId[link.data] : null,
        });
      } else if (o.type === 'image-swatches') {
        layers.push({ kind: 'image', option: o, t: t });
      } else {
        return false;
      }
    }
    if (!layers.length) return false;
    return { bg: bg, layers: layers };
  }

  function optionRoot(option) {
    return document.querySelector('[data-option-id="' + option.id + '"]');
  }

  function isShown(el) {
    return !!(el && el.getClientRects().length);
  }

  /* Secenegin o anki degeri: Easify'in sepete giden gizli input'u (swatch'larda etiket) */
  function optionValue(root) {
    if (!root) return '';
    var hidden = root.querySelector('input[type="hidden"][name^="properties["]');
    return hidden ? hidden.value : '';
  }

  /*
    Metin: musterinin yazdigi gorunur alan. Gizli input'a Easify ek ucreti
    ekliyor ("JOJOCODE (250TL)"), o yuzden yalnizca alan yoksa ona dusulur
    ve sondaki fiyat eki temizlenir.
  */
  function optionText(root) {
    if (!root) return '';
    var field = root.querySelector('input[type="text"], input:not([type]), textarea');
    if (field) return field.value;
    return optionValue(root).replace(/\s*\([^()]*\d[^()]*\)$/, '');
  }

  /* Degeri etiketinden bulur (birebir, sonra "Etiket ..." on eki); fallback varsa varsayilan deger */
  function findValue(option, label, fallback) {
    var types = option.option_types || [];
    var i;
    label = (label || '').trim();
    if (label) {
      for (i = 0; i < types.length; i++) {
        if (types[i].label === label) return types[i];
      }
      for (i = 0; i < types.length; i++) {
        if (types[i].label && label.indexOf(types[i].label) === 0) return types[i];
      }
    }
    if (fallback) {
      for (i = 0; i < types.length; i++) {
        if (types[i].is_default) return types[i];
      }
    }
    return null;
  }

  function loadImage(url) {
    var img = images[url];
    if (!img) {
      img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        lastKey = '';
      };
      img.src = url;
      images[url] = img;
    }
    return img.complete && img.naturalWidth ? img : null;
  }

  /* Musterinin secimlerine gore cizilecek katmanlar; gorsel hazir degilse null */
  function resolveLayers(m) {
    var out = [];
    for (var i = 0; i < m.layers.length; i++) {
      var layer = m.layers[i];
      var root = optionRoot(layer.option);
      if (!isShown(root)) continue;

      if (layer.kind === 'text') {
        var text = optionText(root) || layer.t.text || '';
        if (!text) continue;
        var color = layer.t.default_color || '#000000';
        if (layer.colorOption) {
          var swatch = findValue(layer.colorOption, optionValue(optionRoot(layer.colorOption)), true);
          if (swatch && swatch.color_code) color = swatch.color_code.split(',')[0] || color;
        }
        out.push({ kind: 'text', t: layer.t, text: text, color: color });
      } else {
        var value = findValue(layer.option, optionValue(root));
        if (!value) continue;
        var url = value.image_canvas_url || value.image_url;
        if (!url) continue;
        var img = loadImage(url);
        if (!img) return null;
        out.push({ kind: 'image', t: layer.t, img: img, url: url });
      }
    }
    return out;
  }

  function drawText(layer) {
    var t = layer.t;
    var family = (t.default_font && t.default_font.value) || 'sans-serif';
    var font = function (px) {
      return px + 'px "' + family + '"';
    };
    var chars = Array.from ? Array.from(layer.text) : layer.text.split('');
    var base = (parseFloat(t.size) || 1) * FONT_SCALE;

    /* Easify: genislik bosluklu metinle olculur; max width asilirsa font oranla kuculur */
    ctx.font = font(base);
    var measured = ctx.measureText(' ' + layer.text + ' ').width;
    var maxOn = !!t.max_width_enabled;
    var maxW = parseFloat(t.max_width) || 0;
    var size = maxOn && maxW > 0 && measured > maxW ? (base * maxW) / measured : base;
    var box = maxOn && maxW > 0 ? maxW : measured;
    var align = t.text_align || 'left';
    var offsetX = align === 'center' ? box / 2 : align === 'right' ? box : 0;

    ctx.font = font(size);
    var lineW = 0;
    chars.forEach(function (ch) {
      lineW += ctx.measureText(ch).width + LETTER_SPACING;
    });
    var start = 0;
    if (maxOn && maxW > 0) {
      if (align === 'right') start = maxW - lineW;
      else if (align === 'center') start = (maxW - lineW) / 2;
    }

    ctx.save();
    ctx.translate(parseFloat(t.x_axis) || 0, parseFloat(t.y_axis) || 0);
    ctx.rotate(((parseFloat(t.rotate) || 0) * Math.PI) / 180);
    ctx.globalAlpha = (parseFloat(t.opacity) || 100) / 100;
    ctx.fillStyle = layer.color;
    ctx.textBaseline = 'middle';
    var x = start - offsetX;
    chars.forEach(function (ch) {
      ctx.fillText(ch, x, 0);
      x += ctx.measureText(ch).width + LETTER_SPACING;
    });
    ctx.restore();
  }

  function drawImageLayer(layer) {
    var t = layer.t;
    var w = parseFloat(t.width) || 0;
    var h = parseFloat(t.height) || 0;
    if (!w || !h) return;
    /* FIT: oran korunur, kutuda ortalanir */
    var s = Math.min(w / layer.img.naturalWidth, h / layer.img.naturalHeight);
    var dw = layer.img.naturalWidth * s;
    var dh = layer.img.naturalHeight * s;
    ctx.save();
    ctx.translate(parseFloat(t.x_axis) || 0, parseFloat(t.y_axis) || 0);
    ctx.rotate(((parseFloat(t.rotate) || 0) * Math.PI) / 180);
    ctx.drawImage(layer.img, (w - dw) / 2, (h - dh) / 2, dw, dh);
    ctx.restore();
  }

  /* Modelden yeniden cizim; hazir degilse false (o tur kopyalama kullanilir) */
  function renderModel(m) {
    var bgImg = loadImage(m.bg.image_url);
    if (!bgImg) return false;
    var layers = resolveLayers(m);
    if (!layers) return false;

    /* fonts.status: font sonradan yuklenirse yeniden ciz */
    var key =
      canvas.width + 'x' + canvas.height + '|' +
      (document.fonts ? document.fonts.status : '') + '|' +
      layers
        .map(function (l) {
          return l.kind === 'text' ? l.text + '/' + l.color : l.url;
        })
        .join('|');
    if (key === lastKey) return true;
    lastKey = key;

    var cx = CROP.x * m.bg.width;
    var cy = CROP.y * m.bg.height;
    var cw = CROP.w * m.bg.width;

    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var scale;
    if (ROTATE) {
      ctx.translate(canvas.width, 0);
      ctx.rotate(Math.PI / 2);
      scale = canvas.height / cw;
    } else {
      scale = canvas.width / cw;
    }
    ctx.scale(scale, scale);
    ctx.translate(-cx, -cy);
    ctx.drawImage(bgImg, 0, 0, m.bg.width, m.bg.height);
    layers.forEach(function (layer) {
      if (layer.kind === 'text') drawText(layer);
      else drawImageLayer(layer);
    });
    ctx.restore();
    return true;
  }

  /* Eski yontem: Easify canvas'indan kirpip kopyala (veri okunamazsa) */
  function copyStage(stage) {
    var sx = CROP.x * stage.width;
    var sy = CROP.y * stage.height;
    var sw = CROP.w * stage.width;
    var sh = CROP.h * stage.height;
    lastKey = '';
    try {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (ROTATE) {
        ctx.save();
        ctx.translate(canvas.width, 0);
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(stage, sx, sy, sw, sh, 0, 0, canvas.height, canvas.width);
        ctx.restore();
      } else {
        ctx.drawImage(stage, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
      }
    } catch (e) {
      /* canvas henuz hazir degilse sonraki turda tekrar dener */
    }
  }

  function tick() {
    var stage = document.querySelector('.po-livePreview-stage canvas');
    var visible =
      MOBILE.matches &&
      stage &&
      stage.offsetParent !== null &&
      stage.width > 0;

    if (!visible) {
      if (wrap) wrap.style.display = 'none';
      return;
    }

    ensureBox();
    wrap.style.display = 'block';
    if (model === undefined) model = buildModel();

    /* Serit orani kirpma bolgesinin oranindan (arka plan ya da Easify canvas'i ayni orani tasir) */
    var srcW = model ? model.bg.width : stage.width;
    var srcH = model ? model.bg.height : stage.height;
    var ratio = (CROP.h * srcH) / (CROP.w * srcW);

    var displayW = mode === 'inline' ? wrap.clientWidth - 12 : FLOAT_WIDTH - 12;
    if (displayW < 50) displayW = 50;
    var displayH = Math.round(displayW * (ROTATE ? 1 / ratio : ratio));
    var dpr = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3);
    var pxW = Math.round(displayW * dpr);
    var pxH = Math.round(displayH * dpr);

    if (canvas.width !== pxW || canvas.height !== pxH) {
      canvas.width = pxW;
      canvas.height = pxH;
      canvas.style.height = displayH + 'px';
      if (ctx) ctx.imageSmoothingQuality = 'high';
      lastKey = '';
    }

    if (!(model && renderModel(model))) copyStage(stage);
  }

  function init() {
    setInterval(tick, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
